import {
  ACTIVE_INACTIVE_ORGANISER,
  CREATE_ORGANISER,
  DELETE_ORGANISER,
  DELETE_ORGANISER_IT_SELF,
  GET_ORGANISER,
  LISTOF_CURRENT_EVENT_BY_ORGANISER,
  LISTOF_PAST_EVENT_BY_ORGANISER,
  RESEND_INVITE_ORGANISER,
  SET_ORGANISER_PASSWORD,
} from "../../../api/endPoint";
import instance from "../../../helpers/axios";

const getOrganiser = () => {
  return instance.get(GET_ORGANISER);
};

const createOrganiser = (data) => {
  return instance.post(CREATE_ORGANISER, data);
};

const deleteOrganiser = (id) => {
  return instance.put(`${DELETE_ORGANISER}${id}`);
};
const deleteOrganiserItSelf = () => {
  return instance.put(DELETE_ORGANISER_IT_SELF);
};
const activeInactiveOrganiser = (data) => {
  return instance.put(ACTIVE_INACTIVE_ORGANISER + data?._id, {
    status: data?.status,
  });
};
const resendInviteOrganiser = (data) => {
  return instance.put(RESEND_INVITE_ORGANISER + data?._id);
};
const listOfCurrentEventByOrganiser = (id) => {
  if (id) {
    return instance.get(`${LISTOF_CURRENT_EVENT_BY_ORGANISER}?id=${id}`);
  }
  return instance.get(LISTOF_CURRENT_EVENT_BY_ORGANISER);
};
const listOfPastEventByOrganiser = (id) => {
  if (id) {
    return instance.get(`${LISTOF_PAST_EVENT_BY_ORGANISER}?id=${id}`);
  }

  return instance.get(LISTOF_PAST_EVENT_BY_ORGANISER);
};
const setOrganiserPassword = (data) => {
  return instance.post(SET_ORGANISER_PASSWORD, data);
};

const organiserService = {
  getOrganiser,
  createOrganiser,
  deleteOrganiser,
  activeInactiveOrganiser,
  resendInviteOrganiser,
  listOfCurrentEventByOrganiser,
  listOfPastEventByOrganiser,
  setOrganiserPassword,
  deleteOrganiserItSelf,
};

export default organiserService;
